import React from 'react';
import Loadable from 'react-loadable';

export function loadComponent (componentPath) {
  return Loadable({
    loader: () => import(`../${componentPath}`),
    loading: () => <div className='loader'></div>,
  });
}
